import {Button, ButtonType, PageWithHeader} from 'modules/ui';
import {Trans, useTranslation} from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { LoginSelectors } from 'modules/landingPage/components/login/redux';
import {
  useAppDispatch,
  useAppSelector,
  useQuery,
} from 'modules/hooks/appHooks';
import { LeasingCalculatorPathsEnum } from 'modules/leasingCalculator/routes';
import { useToastContainer } from 'modules/layout/toastContainer';
import { ToastType } from 'modules/ui/toast';
import { LeasingCalculatorThunks } from 'modules/leasingCalculator/redux';
import { ProfilePathsEnum } from 'modules/profilePage/routes';
import { InfoMessage } from 'modules/ui/infoMessage';
import { ButtonsWrapper, InfoWrapper } from './styled';
import { DocumentationPathsEnum } from '../../documentationPage/routes';
import {StyledBody, StyledBoldBody} from "../../ui/pageWithHeader/styled";

export const Homepage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { addToast } = useToastContainer();
  const query = useQuery();

  const user = useAppSelector(LoginSelectors.selectUser);

  const name = useMemo(
    () => (user ? `${user.firstName || user.partnerName}` : query.get('name')),
    [query, user],
  );

  const onCalculatorStart = async () => {
    const result = await dispatch(
      LeasingCalculatorThunks.startLeasingCalculator(),
    );

    if (result.payload === true) {
      history.push(`${LeasingCalculatorPathsEnum.leasingCalculator}`);
    } else {
      addToast({
        type: ToastType.Urgent,
        title: t('leasingCalculator.notAvailableErrorTitle'),
        text: t('leasingCalculator.notAvailableErrorMessage'),
      });
    }
  };

  return (
    <PageWithHeader
      title={`${t('homePage.title', { name })}`}
      description={t('homePage.description')}>
      <InfoWrapper style={{marginBottom: "50px", marginTop: "unset"}}>
        <StyledBody>
          <Trans i18nKey="homePage.fiscalization.title" components={{ b: <StyledBoldBody />}}></Trans>
          <Trans i18nKey="homePage.fiscalization.info" components={{ b: <StyledBoldBody />}}></Trans>
        </StyledBody>
      </InfoWrapper>
      <InfoWrapper>
        <InfoMessage description={t('homePage.infoMessage')} />
      </InfoWrapper>
      <ButtonsWrapper>
        <Button
          text={t('homePage.startCalculator')}
          onClick={onCalculatorStart}
        />
        <Button
          type={ButtonType.Secondary}
          text={t('homePage.documentationOverview')}
          onClick={() => history.push(DocumentationPathsEnum.documentationPage)}
        />
        <Button
          type={ButtonType.Secondary}
          text={t('homePage.profile')}
          onClick={() => history.push(ProfilePathsEnum.profilePage)}
        />
      </ButtonsWrapper>
    </PageWithHeader>
  );
};
